import React, { useState } from "react";
import styles from "../styles/Dashboard.module.css";
import logo from "../img/logo.jpg";
import Usuarios from "./Usuarios";
import Perfiles from "./Perfiles";
import Clinicas from "./Clinicas";
import Veterinarios from "./Veterinarios";
import Pacientes from "./Pacientes";
import Citas from "./Citas";
import Facturacion from "./Facturacion";
import Perfil from "./Perfil";
import { handleLogout } from "../handlers/usuarios";

const Dashboard = () => {
  const profile = localStorage.getItem("profile_id");
  const full_name = localStorage.getItem("full_name");
  const username = full_name ? full_name : "Invitado";
  const [selectedSection, setSelectedSection] = useState("");

  // handleLogout ahora proviene de handlers/usuarios.js

  // Renderiza el componente según la sección seleccionada
  const renderSection = () => {
    switch (selectedSection) {
      case "usuarios":
        return <Usuarios />;
      case "perfiles":
        return <Perfiles />;
      case "clinicas":
        return <Clinicas />;
      case "veterinarios":
        return <Veterinarios />;
      case "pacientes":
        return <Pacientes />;
      case "citas":
        return <Citas />;
      case "facturacion":
        return <Facturacion />;
      case "perfil":
        return <Perfil />;
      default:
        return (
          <>
            <h2 className={styles.title}>Bienvenido, {username}</h2>
          </>
        );
    }
  };

  const sectionTitles = {
    usuarios: "Gestión de Usuarios",
    perfiles: "Gestión de Perfiles",
    clinicas: "Gestión de Clínicas",
    veterinarios: "Gestión de Veterinarios",
    pacientes: "Gestión de Pacientes",
    citas: "Gestión de Citas",
    facturacion: "Gestión de Facturación",
    perfil: "Gestión de Perfil",
  };

  return (
    <div className={styles.adminContainer}>
      <aside className={styles.sidebar}>
        <img src={logo} alt="Logo" className={styles.logo} />
        <ul className={styles.menu}>
          {profile === "1" && (
            <li>
              <button className={styles.menuButton} onClick={() => setSelectedSection("usuarios")}>
                👥 Usuarios
              </button>
            </li>
          )}
          {profile === "1" && (
            <li>
              <button className={styles.menuButton} onClick={() => setSelectedSection("perfiles")}>
                🗂️ Perfiles
              </button>
            </li>
          )}
          {(profile === "1" || profile === "2") && (
            <li>
              <button className={styles.menuButton} onClick={() => setSelectedSection("clinicas")}>
                🏥 Clínicas
              </button>
            </li>
          )}
          {(profile === "1" || profile === "2") && (
            <li>
              <button className={styles.menuButton} onClick={() => setSelectedSection("veterinarios")}>
                🩺 Veterinarios
              </button>
            </li>
          )}
          {(profile === "1" || profile === "2") && (
            <li>
              <button className={styles.menuButton} onClick={() => setSelectedSection("pacientes")}>
                🐾 Pacientes
              </button>
            </li>
          )}
          {(profile === "1" || profile === "2") && (
            <li>
              <button className={styles.menuButton} onClick={() => setSelectedSection("citas")}>
                📅 Citas
              </button>
            </li>
          )}
          {profile === "1" && (
            <li>
              <button className={styles.menuButton} onClick={() => setSelectedSection("facturacion")}>
                💳 Facturación
              </button>
            </li>
          )}
          <li>
            <button className={styles.menuButton} onClick={() => setSelectedSection("perfil")}>
              👤 Perfil
            </button>
          </li>
          <li>
            <button className={styles.logout} onClick={handleLogout}>
              🚪 Cerrar Sesión
            </button>
          </li>
        </ul>
      </aside>
      <div className={styles.contentArea}>
        <header className={styles.topbar}>
          <h1 className={styles.pageTitle}>
            {selectedSection
              ? sectionTitles[selectedSection] || "Panel de Administración Veterinaria"
              : "Panel de Administración Veterinaria"}
          </h1>
        </header>
        <main className={styles.mainContent}>
          {renderSection()}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
